import React, { FC } from "react";

import PinLegendDatingMethod from "@mapmycustomers/shared/enum/pinLegends/PinLegendDatingMethod";

import AbsoluteDatesEditor from "./AbsoluteDatesEditor";
import Breakpoints from "./Breakpoints";
import OrdinalDatesEditor from "./OrdinalDatesEditor";
import RelativeDatesEditor from "./RelativeDatesEditor";

const numberComparator = (a: number, b: number) => a - b;
const absoluteDateComparator = (a: string, b: string) => a.localeCompare(b);
const ordinalDateComparator = (a: string, b: string) => {
  const [aMonth, aDay] = a.split("-");
  const [bMonth, bDay] = b.split("-");

  const monthDiff = parseInt(aMonth, 10) - parseInt(bMonth, 10);
  return monthDiff || parseInt(aDay, 10) - parseInt(bDay, 10);
};

export interface NumericBreakpointsProps {
  breakpoints?: number[] | string[];
  datingMethod: PinLegendDatingMethod;
  onChange?: (value: number[] | string[]) => void;
  onError?: (hasError: boolean) => void;
}

const DateBreakpoints: FC<NumericBreakpointsProps> = ({ breakpoints, datingMethod, ...props }) => {
  switch (datingMethod) {
    case PinLegendDatingMethod.ABSOLUTE:
      return (
        <Breakpoints
          comparator={absoluteDateComparator}
          editComponent={AbsoluteDatesEditor}
          value={breakpoints as string[]}
          {...props}
        />
      );
    case PinLegendDatingMethod.ORDINAL:
      return (
        <Breakpoints
          comparator={ordinalDateComparator}
          editComponent={OrdinalDatesEditor}
          value={breakpoints as string[]}
          {...props}
        />
      );
    case PinLegendDatingMethod.RELATIVE:
      return (
        <Breakpoints
          comparator={numberComparator}
          editComponent={RelativeDatesEditor}
          value={breakpoints as number[]}
          {...props}
        />
      );
  }
};

export default DateBreakpoints;
